export default __webpack_public_path__ + "static/media/ajaxLoaderBig3.6264ce97.gif";